<h2 mat-dialog-title>Import Roster</h2>

<mat-dialog-content>
  <!-- PHASE: idle -->
  @if (phase === 'idle') {
    <p class="import-hint">
      Upload an exported roster Excel file to apply bulk updates. Only editable columns are processed. The action column
      (Certify? / Endorsed?) is applied only when set to <strong>Yes</strong>.
    </p>
    <div class="file-picker">
      <button mat-raised-button color="primary" (click)="fileInput.click()">
        <mat-icon>upload_file</mat-icon>
        Choose File (.xlsx)
      </button>
      <input #fileInput type="file" accept=".xlsx" style="display: none" (change)="onFileSelected($event)" />
    </div>
    @if (xlsxError) {
      <p class="file-type-error">{{ xlsxError }}</p>
    }
  }

  <!-- PHASE: processing -->
  @if (phase === 'processing') {
    <p class="processing-label">Processing imported roster, please wait…</p>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <!-- PHASE: done -->
  @if (phase === 'done') {
    <mat-progress-bar mode="determinate" value="100" class="done-bar"></mat-progress-bar>

    @if (importError) {
      <div class="result-error-banner">
        <mat-icon>error</mat-icon>
        <span>{{ importError }}</span>
      </div>
    }

    @if (result) {
      <div class="result-summary" [class.has-errors]="hasErrors">
        <mat-icon class="summary-icon">{{ hasErrors ? 'warning' : 'check_circle' }}</mat-icon>
        <span>
          <strong>{{ result.successCount }}</strong> updated, <strong>{{ result.skipCount }}</strong> skipped (no
          changes), <strong>{{ result.errors.length }}</strong> errored — <strong>{{ result.totalRows }}</strong> total
          rows.
        </span>
      </div>

      @if (hasErrors) {
        <textarea readonly class="error-textarea">{{ errorText }}</textarea>
      }
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (phase === 'idle' || phase === 'processing') {
    <button mat-button mat-dialog-close [disabled]="phase === 'processing'">Cancel</button>
  }
  @if (phase === 'done') {
    <button mat-raised-button color="primary" (click)="closeAndRefresh()">
      {{ result && result.successCount > 0 ? 'Close & Refresh' : 'Close' }}
    </button>
  }
</mat-dialog-actions>
